import {AUTHORIZED_VIEW} from "../../constants/appConstant";
import React from "react";
import {useUserContext} from "../../context/UserContextProvider";

const DecideRightPanelIconVisibility = () => {
    const {userView} = useUserContext();
    return userView === AUTHORIZED_VIEW
}
export default DecideRightPanelIconVisibility;
